module.exports = __webpack_public_path__ + "media/images/steps/step_7-b37025dcbb0a2b02032d0d47d05f1776.svg";